import React, { useState } from "react";
import StudentFilesTable from "../../../Components/layouts/StudentCourse/StudentFilesTable";
import useFetch from "../../../Hooks/useFetch";
import MainPagination from "../../../Components/share/Pageination/MainPagination";

function StudentFiles() {
    const [userHomeworks, setUserHomeworks] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const getUserHomeworks = useFetch({
        method: "GET",
        url: `UserBootCampHomeworkService/user_bootcamp_files/?bootcamp_id=11`,
        //pagination: pagination,
        noHeader: false,
        trigger: true,
        isNew: true,
        setter: setUserHomeworks,
    });
    //TODO : id bootcamp dynamic she

    return (
        <div>
            <div className="flex justify-between items-center">
                <h4 className="text-[2rem] text-purple-dark font-bold">
                    اطلاعات فایل های بوت کمپ
                </h4>
            </div>
            <StudentFilesTable list={userHomeworks} header={header} />
            <MainPagination
                pagination={pagination}
                setPagination={setPagination}
                data={userHomeworks?.results}
                pageSize={userHomeworks?.page_count}
            />
        </div>
    );
}

export default StudentFiles;
const header = [
    { title: "نام فایل" },
    { title: "بخش" },
    { title: "تاریخ بارگزاری" },
];
